import { Info } from "lucide-react";

export const RemunInfoFooter = () => {
  return (
    <div className="sticky bottom-0 z-40 w-full bg-slate-50/90 backdrop-blur-md border-t border-slate-200/80 px-3 py-4 md:px-6">
      <div className="container mx-auto max-w-4xl flex items-center justify-center gap-2 sm:gap-2.5">
        <div className="shrink-0 flex items-center justify-center bg-blue-50 p-1 rounded-full border border-blue-100">
          <Info className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-blue-600" />
        </div>
        <p className="text-[10px] sm:text-xs text-slate-600 font-medium leading-relaxed text-center max-w-3xl">
          Semua proses perhitungan, tampilan data dan informasi pada sistem
          remunerasi ini sesuai ketentuan dari{" "}
          <span className="font-semibold text-blue-700">
            Tim Remunerasi Undiksha
          </span>
          . Jika ada pertanyaan/feedback bisa melalui tombol Ajukan/Pertanyaan
          di atas. Terima kasih.
        </p>
      </div>
    </div>
  );
};
